import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { SETTINGS } from "@/constants/testIds";
import {
  ProfileCurrentPasswordField, ProfileIdentityFields, ProfilePasswordFields,
} from "@/components/settings/ProfileFields";

const EMPTY_PROFILE = {
  email: "", display_name: "", current_password: "", new_password: "", confirm_password: "",
};
const CLEARED_PASSWORDS = { current_password: "", new_password: "", confirm_password: "" };

export function ProfileSettings({ user, refreshUser, onSave }) {
  const [profile, setProfile] = useState(EMPTY_PROFILE);
  const [saving, setSaving] = useState(false);
  const update = (patch) => setProfile((p) => ({ ...p, ...patch }));

  useEffect(() => {
    if (user) setProfile((p) => ({ ...p, email: user.email || "", display_name: user.display_name || "" }));
  }, [user]);

  const handleSave = async () => {
    setSaving(true);
    const result = await onSave(profile, user, refreshUser);
    if (result?.ok) update(CLEARED_PASSWORDS);
    setSaving(false);
  };

  return (
    <Card className="p-6 border-slate-200 shadow-sm max-w-2xl">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-base font-semibold text-slate-900">Mi perfil</h3>
          <p className="text-xs text-slate-500 mt-0.5">
            Actualiza tu correo, nombre y contraseña de administrador. Se requiere tu contraseña actual para confirmar los cambios.
          </p>
        </div>
        <Badge className="bg-slate-100 text-slate-700 hover:bg-slate-100 border-slate-200">
          {user?.role || "admin"}
        </Badge>
      </div>

      <div className="space-y-4">
        <ProfileIdentityFields profile={profile} update={update} />
        <ProfilePasswordFields profile={profile} update={update} />
        <ProfileCurrentPasswordField profile={profile} update={update} />
      </div>

      <div className="mt-6 flex justify-end">
        <Button onClick={handleSave} disabled={saving}
          className="bg-orange-600 hover:bg-orange-700 text-white"
          data-testid={SETTINGS.saveProfileBtn}>
          {saving ? "Guardando..." : "Guardar cambios"}
        </Button>
      </div>
    </Card>
  );
}
